import axios from 'axios';

let prefix = "/creep-pip"

const CreepPipApi = {
	getCreepPipCategories(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getCreepPipCategory(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getCreepPipStatKeys(payload) {
		return axios.get(prefix + "/stat-keys", { params: payload })
	},
	createCreepPipCategory(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateCreepPipCategory(payload) {
		return axios.post(prefix + "/update", payload)
	},
	archiveCreepPipCategory(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
}

export default CreepPipApi;
